import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import "./App.css";
import { MenuProvider } from "./components/MenuProvider";
import { DrawerProvider } from "./components/context/DrawerContext"; //
import { MenuStateProvider } from "./components/context/MenuStateContext";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

import { SelectionProvider } from './components/context/SelectionContext';
// import {  BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Users from "./pages/administrar/users/list";
import UsersAdd from "./pages/administrar/users/add";
import Oficinas from "./pages/administrar/oficinas/list";
import OficinasAdd from "./pages/administrar/oficinas/add";
import OficinasEdit from "./pages/administrar/oficinas/edit";

import Privilegios from "./pages/administrar/privilegios/list";
import PrivilegiosAdd from "./pages/administrar/privilegios/add";

import TipoGasto from "./pages/administrar/gastos/list";
import TipoGastoAdd from "./pages/administrar/gastos/add";
import TipoGastoEdit from "./pages/administrar/gastos/edit";

import Empleados from "./pages/administrar/empleados/list";
import EmpleadosAdd from "./pages/administrar/empleados/add";
import EmpleadosEdit from "./pages/administrar/empleados/edit";

import Clientes from "./pages/administrar/clientes/list";
import ClientesAdd from "./pages/administrar/clientes/add";
import ClientesEdit from "./pages/administrar/clientes/edit";

import Cobros from "./pages/administrar/cobros/list";
import CobrosAdd from "./pages/administrar/cobros/add";
import CobrosEdit from "./pages/administrar/cobros/edit";

import Constantes from "./pages/administrar/constantes/list";
import ConstantesAdd from "./pages/administrar/constantes/add";
import ConstantesEdit from "./pages/administrar/constantes/edit";

import AssignAdd from "./pages/administrar/constantes/assign";

import ListBox from "./pages/administrar/cajas/list";

import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

import Abonos from "./pages/prestamos/abonos/list";
import AbonosAdd from "./pages/prestamos/abonos/add";

import UserEdit from "./pages/administrar/users/edit";
import UserOffice from "./pages/administrar/users/office";
import PrivateRoute from "./components/common/PrivateRoute";
import RequireMenuVisibility from "./components/common/RequireMenuVisibility";
import InformeAbonosAdd from "./pages/prestamos/abonoporfecha/abonoporfecha";
import ActualizarTerminalAdd from "./pages/prestamos/actualizarterminal/add";
import AdminDetalleGastos from "./pages/administrar/cajas/detail";



import ExportarClientes from "./pages/prestamos/procesos/exportarClientes";
import LiquidacionCobros from "./pages/procesos/liquidar/liquidarCobro";
import DetalleGastoAdd from "./pages/prestamos/gastos/add";
import DetalleGastoEdit from "./pages/prestamos/gastos/edit";
import DetalleGastos from "./pages/prestamos/gastos/list";
import AbonosPagos from "./pages/prestamos/abonos/pagos";
import TransferirPrestamo from "./pages/procesos/Transferirprestamo/transferirprestamo";

import InformeCancelacion from "./pages/informes/cancelacionFecha";
import ReporteGastos from "./pages/informes/gastos";
import ClientesHist from "./pages/informes/clienteshist";
import ReportePrestamoFecha from "./pages/informes/prestamosFecha";
import ResumenSaldo from "./pages/informes/resumenSaldo";
import DiasAtraso from "./pages/informes/diasAtraso";
import ResumenDescuadre from "./pages/informes/resumenDescuadre";
import ResumenDia from "./pages/informes/resumenDia";
import ReporteDescuentos from "./pages/informes/descuentosFecha";
import ReporteTransmision from "./pages/informes/transmision";
import RegistrosBorrados from "./pages/informes/registrosBorrados";

import ResumenConsolidadoDia from "./pages/reportes/consolidadoDia";
import ReporteCajas from "./pages/reportes/cajasOficinas";
import Refinanciacion from "./pages/reportes/refinanciacion";
import MovimientoCaja from "./pages/reportes/movimientoCajas";

import ImportarClientes from "./pages/procesos/importarclientes/importarclientes";
import ImportarPrestamos from "./pages/procesos/importarprestamos/importarprestamos";
import ImportarPrestamosList from "./pages/procesos/importarprestamos/list";
import MobileSyncAuditList from "./pages/procesos/auditoriaSync/list";
import EliminarPrestamos from "./pages/procesos/eliminarprestamos/eliminarprestamos";
import EliminarClientes from "./pages/procesos/eliminarclientes/eliminarclientes";

import { Module } from "./models/module";
import UserCollect from "./pages/administrar/users/collect";
import Wrapper from "./components/Wrapper";
import AlertSnackbar from "./components/AlertSnackbar";
import LoadingBackdrop from "./components/LoadingBackdrop";
import EmployeOffice from "./pages/administrar/empleados/office";
import EmployeCollect from "./pages/administrar/empleados/collect";
import CajaPrincipalAdd from "./pages/administrar/cajas/add";
import GastosAdd from "./pages/prestamos/gastos/add";
import EditPay from "./pages/prestamos/modificarabonos/add";
import Invoice from "./pages/prestamos/abonos/modal/invoice";
import RutasList from "./pages/procesos/rutas/list";
import RutasOffList from "./pages/procesos/rutasOff/list";
import DoRoute from "./pages/procesos/rutero/list";
import RutaSeguimiento from "./pages/procesos/rutaSeguimiento/seguimiento";
import Bancos from "./pages/administrar/bancos/list";
import BancoEdit from "./pages/administrar/bancos/edit";
import BancoAdd from "./pages/administrar/bancos/add";
import MobileLicenseNoticeAdmin from "./pages/procesos/mobileLicenseNotice/mobileLicenseNotice";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState<boolean>(true);
  const [modules, setModules] = useState<Module[]>(() => {
    const modulesFromSession = sessionStorage.getItem("modules");
    if (modulesFromSession) return JSON.parse(modulesFromSession);
    const modulesFromLocal = localStorage.getItem("modules");
    return modulesFromLocal ? JSON.parse(modulesFromLocal) : [];
  });
  useEffect(() => {
    let mounted = true;

    const bootstrapAuth = async () => {
      try {
        await axios.get("user");
        if (!mounted) return;
        setIsAuthenticated(true);
      } catch (_) {
        if (!mounted) return;
        setIsAuthenticated(false);
        sessionStorage.removeItem("isAuthenticated");
        sessionStorage.removeItem("modules");
        localStorage.removeItem("modules");
      } finally {
        if (mounted) {
          setIsCheckingAuth(false);
        }
      }
    };

    bootstrapAuth();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("isAuthenticated", isAuthenticated.toString());
  }, [isAuthenticated]);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertSeverity, setAlertSeverity] = useState<"success" | "info" | "warning" | "error">("success");
  const [loading, setLoading] = useState<boolean>(false);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const showAlert = useCallback(
    (message: string, severity: "success" | "info" | "warning" | "error" = "success") => {
      setAlertMessage(message);
      setAlertSeverity(severity);
      setAlertOpen(true);
    },
    [],
  );

  const showLoading = useCallback(() => {
    setLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <Router>
      <DrawerProvider>
        <MenuStateProvider>
          <SelectionProvider>
            <Routes>
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} setModules={setModules} />} />
              <Route
                path="/*"
                element={
                  <PrivateRoute
                    isAuthenticated={isAuthenticated}
                    isCheckingAuth={isCheckingAuth}
                    redirectPath="/login"
                  >
                    <MenuProvider initialModules={modules}>
                      <Wrapper>
                        <Routes>

                          <Route path="/" element={<Dashboard showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="dashboard" element={<Dashboard showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          {/* Administrar */}
                          <Route path="administrar/usuarios" element={<Users showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/usuarios/add" element={<UsersAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/usuarios/:id/editar" element={<UserEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/usuarios/:id/oficinas" element={<UserOffice />} />
                          <Route path="administrar/usuarios/:id/cobros" element={<UserCollect />} />

                          <Route path="administrar/bancos" element={<Bancos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/bancos/:id/editar" element={<BancoEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/bancos/add" element={<BancoAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          
                          <Route path="administrar/oficinas" element={<Oficinas showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/oficinas/add" element={<OficinasAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/oficinas/:id/editar" element={<OficinasEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="administrar/empleados" element={<Empleados showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/empleados/add" element={<EmpleadosAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/empleados/:id/editar" element={<EmpleadosEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/empleados/:id/oficinas" element={<EmployeOffice showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/empleados/:id/cobros" element={<EmployeCollect showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="administrar/clientes" element={<Clientes showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/clientes/add" element={<ClientesAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/clientes/:id/editar" element={<ClientesEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="administrar/cobros" element={<Cobros showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/cobros/add" element={<CobrosAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/cobros/:id/editar" element={<CobrosEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="administrar/constantes" element={<Constantes showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/constantes/add" element={<ConstantesAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/constantes/:id/editar" element={<ConstantesEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/constantes/assign" element={<AssignAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="administrar/tipogasto" element={<TipoGasto showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/tipogasto/add" element={<TipoGastoAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/tipogasto/:id/editar" element={<TipoGastoEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="administrar/privilegios" element={<Privilegios showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/privilegios/add" element={<PrivilegiosAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="administrar/detallegasto" element={<DetalleGastos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/detallegasto/add" element={<DetalleGastoAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="administrar/detallegasto/:id/editar" element={<DetalleGastoEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route
                            path="administrar/cajas"
                            element={
                              <RequireMenuVisibility resourceRoute="/administrar/cajas">
                                <ListBox showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />
                              </RequireMenuVisibility>
                            }
                          />
                          <Route
                            path="administrar/cajas/add"
                            element={
                              <RequireMenuVisibility resourceRoute="/administrar/cajas/add">
                                <CajaPrincipalAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />
                              </RequireMenuVisibility>
                            }
                          />
                          <Route
                            path="administrar/cajas/detail"
                            element={
                              <RequireMenuVisibility resourceRoute="/administrar/cajas/detail">
                                <AdminDetalleGastos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />
                              </RequireMenuVisibility>
                            }
                          />


                          {/* Prestamos */}
                          <Route path="prestamos/abonos/list" element={<Abonos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="prestamos/abonos/add" element={<AbonosAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="prestamos/abonos/:id/pagos" element={<AbonosPagos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="prestamos/abonos/pagos/invoice/:id" element={<Invoice showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="prestamos/abonosporfecha" element={<InformeAbonosAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="prestamos/gastos/list" element={<DetalleGastos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="prestamos/gastos/add" element={<GastosAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="prestamos/detallegasto/:id/editar" element={<DetalleGastoEdit showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="prestamos/modificarabono" element={<EditPay showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="prestamos/actualizarterminal" element={<ActualizarTerminalAdd showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />


                          {/* Informes */}
                          <Route path="informes/cancelacion" element={<InformeCancelacion showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          {/* <Route path="informes/cancelacion/:id/historico" element={<HistoricoCliente />} /> */}

                          <Route path="informes/reportegastos" element={<ReporteGastos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          {/* <Route path="informes/historicocliente" element={<HistoricoCliente  />} /> */}
                          <Route path="informes/historicocliente" element={<ClientesHist showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="informes/reporteprestamo" element={<ReportePrestamoFecha showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="informes/resumensaldo" element={<ResumenSaldo showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="informes/diasatraso" element={<DiasAtraso />} />

                          <Route path="informes/resumendescuadre" element={<ResumenDescuadre showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="informes/resumendia" element={<ResumenDia showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="informes/reportedescuento" element={<ReporteDescuentos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="informes/transmision" element={<ReporteTransmision showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                          <Route path="informes/registrosborrados" element={<RegistrosBorrados showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />


                          {/* Reportes */}

                          <Route path="reportes/resumendia" element={<ResumenConsolidadoDia showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reportes/reportecajas" element={<ReporteCajas showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reportes/refinanciacion" element={<Refinanciacion showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="reportes/movimientocaja" element={<MovimientoCaja showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />


                          {/* Procesos */}

                          <Route path="procesos/rutas" element={<RutasList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="procesos/rutero" element={<DoRoute showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="procesos/rutasoffline" element={<RutasOffList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="procesos/ruta-seguimiento" element={<RutaSeguimiento showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="procesos/liquidacioncobros" element={<LiquidacionCobros showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="procesos/exportarclientes" element={<ExportarClientes />} />

                          <Route path="procesos/importarclientes" element={<ImportarClientes />} />

                          <Route path="procesos/importarprestamo" element={<ImportarPrestamos showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="procesos/importaciones" element={<ImportarPrestamosList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route path="procesos/auditoria-sincronizacion" element={<MobileSyncAuditList showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />

                          <Route
                            path="procesos/aviso-licencia-mobile"
                            element={<MobileLicenseNoticeAdmin showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />}
                          />

                          <Route path="procesos/eliminarprestamos" element={<EliminarPrestamos />} />

                          <Route path="procesos/eliminarclientes" element={<EliminarClientes />} />

                          <Route path="procesos/TransferirPrestamo" element={<TransferirPrestamo showAlert={showAlert} showLoading={showLoading} hideLoading={hideLoading} />} />
                        </Routes>
                      </Wrapper>
                      <AlertSnackbar
                        open={alertOpen}
                        message={alertMessage}
                        severity={alertSeverity}
                        handleClose={handleAlertClose}
                      />
                      <LoadingBackdrop open={loading} />
                    </MenuProvider>
                  </PrivateRoute>
                }
              />
            </Routes>
          </SelectionProvider>
        </MenuStateProvider>
      </DrawerProvider>
    </Router>
  );
};


export default App;
